const USER_TYPES = ["CLIENT", "DRIVER", "ENTERPRISE", "SYSTEM"];

export function validateCancellationReasonPayload(payload) {
  if (!payload?.code?.trim()) {
    return "El codigo es obligatorio.";
  }

  if (payload.code.trim().length > 50) {
    return "El codigo no debe exceder 50 caracteres.";
  }

  if (!payload?.name?.trim()) {
    return "El motivo es obligatorio.";
  }

  if (payload.name.trim().length > 100) {
    return "El motivo no debe exceder 100 caracteres.";
  }

  if (!USER_TYPES.includes(payload?.actor_type)) {
    return "El usuario no es valido.";
  }

  return null;
}
